<template>
  <div class="installment-schedule mt2">
    <table class="installment-schedule__table">
      <thead>
        <tr>
          <th class="installment-schedule__cell installment-schedule__cell--head">
            Dates des futurs échéances
          </th>
          <th class="installment-schedule__cell installment-schedule__cell--head installment-schedule__cell--amount">
            Montant
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(installment, index) in installments" :key="installment.dueDate">
          <td class="installment-schedule__cell">{{ formatDueDate(installment.dueDate) }} {{ (index === 0) ? ' (1er paiement)' : '' }}</td>
          <td class="installment-schedule__cell installment-schedule__cell--amount">{{ formatAmount(installment.amount) }} €</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { format } from 'date-fns';
import { fr as frLocale } from 'date-fns/locale/fr';

const props = defineProps({
  installments: {
    type: Array,
    required: true
  }
});

const formatAmount = amount => (amount / 100).toFixed(2);

const formatDueDate = dueDate => format(new Date(parseFloat(dueDate)), 'dd MMMM', { locale: frLocale });
</script>

<style scopped>

.installment-schedule {
  border: 1px solid #d1d1d1;
  border-radius: 8px;
  overflow: hidden;
}

.installment-schedule__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.installment-schedule__cell {
  padding: 10px 14px;
  border-bottom: 1px solid #d1d1d1;
  border-right: 1px solid #d1d1d1;
  background: #fff;
  text-align: left;
  vertical-align: middle;
  color: #1a1a1a;
}

.installment-schedule__cell:last-child {
  border-right: none;
}

.installment-schedule tbody tr:last-child .installment-schedule__cell {
  border-bottom: none;
}

.installment-schedule__cell--head {
  font-weight: bold;
  background: #e9e4d9;
  border-bottom: 1px solid #d1d1d1;
}

.installment-schedule__cell--amount {
  text-align: right;
  white-space: nowrap;
}
</style>
